import { Links } from "../types";
import routeIcons from "../components/icons";

// ! The permissions listed do not relate to the admin dashboard but the pages are protected by SUPER ADMINs only so no additional permission is necessary
const adminSidebarLinks: Links = {
  Workspaces: {
    type: "Page",
    open: false,
    route: "workspace",
    permission: "ADMIN_SETTINGS_READ",
    subPages: [],
    icon: routeIcons.workspaces,
  },
  "Super Admins": {
    type: "Page",
    open: false,
    route: "super-admin",
    permission: "ADMIN_SETTINGS_READ",
    subPages: [],
    icon: routeIcons.adminSettings,
  },
};

export default adminSidebarLinks;
